export const roundDown = function (num, precision) {
  if (!num) return "-";
  num = parseFloat(num);
  if (!precision) return num.toLocaleString("de") + " EUR";
  return (
    (Math.floor(num / precision) * precision).toLocaleString("de") + " EUR"
  );
};
